import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { ITimeInterval } from '../models/time-interval.interface';

export const timeIntervalConfig: ITimeInterval[] = [
  {
    countryCode: COUNTRY_CODE.USA,
    timeIntervalReadyMix: 5,
    timeIntervalDefault: 5,
  },
  {
    countryCode: COUNTRY_CODE.UNITED_KINGDOM,
    timeIntervalReadyMix: 10,
    timeIntervalDefault: 5,
  },
];
